import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const ScheduleOverview = lazy(() => import('./schedule-overview'));
const ScheduleCreate = lazy(() => import('./schedule-create/schedule-create.component'));
const ScheduleDetail = lazy(() => import('./schedule-detail/schedule-detail.component'));
const ScheduleUpdate = lazy(() => import('./schedule-update/schedule-update.component'));

export function ScheduleRoutes() {
    return (
        <Route path='schedules'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <ScheduleOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <ScheduleCreate />
                    </AsyncComponent>
                }
            />

            <Route path=':scheduleId'>
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <ScheduleUpdate />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <ScheduleDetail />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}
